module.exports = __webpack_public_path__ + "static/media/rectangle-23.f6895b8e.svg";